import gql from 'graphql-tag';
import showToaster from '../../../helpers/showToaster';

export function updateTempImages(tableName, fieldName, fileName) {

  return async (dispatch, getState, { client }) => {
    const mutation = gql`
        mutation updateTempImages(
          $tableName: String,
          $fieldName: String,
          $fileName: String
        ) {
        updateTempImages(
          tableName: $tableName,
          fieldName: $fieldName,
          fileName: $fileName
        ){
          status
        }
      }
    `;


    const { data } = await client.mutate({
      mutation,
      variables: {
        tableName,
        fieldName,
        fileName
      }
    });


    if (data && data.updateTempImages && data.updateTempImages.status == 200) {
      showToaster({ messageId: 'updateTempImages', toasterType: 'success', requestContent: fileName })
    } else {
      showToaster({ messageId: 'commonError', toasterType: 'error' })
    }
  }
}